import React from 'react';
import { MdOutlineImageNotSupported } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';

interface NoImageProps {
	text?: string;
}

export default function NoImage({ text = 'noImage' }: NoImageProps) {
	const { t }: UseTranslationProps = useTranslation();

	return (
		<S.container>
			<MdOutlineImageNotSupported />
			<p>{t(text)}</p>
		</S.container>
	);
}
